'use client'
import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";



function ForeignQuotaFilter({ title, dictionary }) {
    const router = useRouter();

    const [foreignQuota, setForeignQuota] = useState(false)

    const handleUpdateParams = (e) => {
        console.log(e)
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams(title, e);
        } else {
            newPathName = removeSearchParam(title);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const fqValue = getSearchParams('foreignquota')

        if (fqValue == 'true') {
            setForeignQuota(true)
        } else {
            setForeignQuota(false)
        }
    }, [handleUpdateParams])

    return (
        <div className='sm:w-1/2 w-full flex flex-row items-center justify-between mt-2 px-1'>
            <span className='text-sm text-secondary'>{dictionary.filter.onlyIncludeForeignQuota}</span>
            <Switch
                checked={foreignQuota}
                // onChange={setPetFriendly}
                onChange={(value) => {
                    setForeignQuota(value)
                    handleUpdateParams(value)
                }}
                className={`${foreignQuota ? 'bg-maincolor' : 'bg-forth'
                    } inline-flex h-6 w-11 items-center rounded-full border-[1px] border-forth shadow-sm`}
            >
                <span className="sr-only">{dictionary.filter.onlyIncludeForeignQuota}</span>
                <span
                    className={`${foreignQuota ? 'translate-x-6' : 'translate-x-1'
                        } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                />
            </Switch>
        </div>
    )
}

export default ForeignQuotaFilter